export default "__VITE_ASSET__Dos0JHor__"